import React, { createContext, useState, useMemo } from "react";

export type FindifyMenuContextType = {
    isSidemenuOpen: boolean;
    setIsSidemenuOpen: (isOpen: boolean) => void;
    isSidemenu: boolean;
    setIsSidemenu: (isSidemenu: boolean) => void;
    hasSidemenuItems: boolean;
    setHasSidemenuItems: (hasItems: boolean) => void;
    activeMuseumSlug: string | null;
    setActiveMuseumSlug: (slug: string | null) => void;
    activeMuseumTitle: string | null;
    setActiveMuseumTitle: (title: string | null) => void;
}

export const FindifyMenuContext = createContext<FindifyMenuContextType | null>(null);

export const FindifyMenuProvider = ({ children }: { children: React.ReactNode }) => {
    const [isSidemenuOpen, setIsSidemenuOpen] = useState(false);
    const [isSidemenu, setIsSidemenu] = useState(false);
    const [hasSidemenuItems, setHasSidemenuItems] = useState(false);
    const [activeMuseumSlug, setActiveMuseumSlug] = useState<string | null>(null);
    const [activeMuseumTitle, setActiveMuseumTitle] = useState<string | null>(null);

    const value = useMemo(() => ({
        isSidemenuOpen,
        setIsSidemenuOpen,
        isSidemenu,
        setIsSidemenu,
        hasSidemenuItems,
        setHasSidemenuItems,
        activeMuseumSlug,
        setActiveMuseumSlug,
        activeMuseumTitle,
        setActiveMuseumTitle
    }), [isSidemenuOpen, isSidemenu, hasSidemenuItems, activeMuseumSlug, activeMuseumTitle]);

    return (
        <FindifyMenuContext.Provider value={value}>
            {children}
        </FindifyMenuContext.Provider>
    );
};
